module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie Sorter Creates a clickable Nessie Icon with up/down toggle. Defaults to Descending icon.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;Sorter sort=&quot;up&quot; /&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Sorter/README.md
// module id = 388
// module chunks = 0